import { render } from "./TableSortable.vue?vue&type=template&id=08d83fb8&scoped=true"
import script from "./TableSortable.vue?vue&type=script&lang=js"
export * from "./TableSortable.vue?vue&type=script&lang=js"

import "./TableSortable.vue?vue&type=style&index=0&id=08d83fb8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d83fb8"]])

export default __exports__